<template>
  <div class="message-container">
    <div class="message-wrapper">
      <p class="-title">
        <b>パーツセットを選択してください</b>
      </p>
      <div class='table-wrapper'>
        <table class='table-box'>
          <tr>
            <th class='table-cell'>ロボ名</th>
            <th class='table-cell'>パーツセット</th>
          </tr>
          <tr>
            <td class='table-cell'>[メインロボ]{{chatbot.name}}</td>
            <td class='table-cell'>
              <b-field class='parts-set-select'>
                <b-select placeholder="パーツセット名" :value="getRoboPartsSet" @input="updateSelect($event, -1)" :disabled="scenarioEdit.is_confirm">
                  <option v-for="(partsSet, index) in roboPartsSet" :key="index" :value="partsSet.robo_parts_set_id">
                    {{partsSet.robo_parts_set_name}}
                  </option>
                </b-select>
              </b-field>
            </td>
          </tr>
          <tr v-for="(mini, i) in chatbot.chatbot_mini" :key="i">
            <td class='table-cell'>{{mini.name}}</td>
            <td class='table-cell'>
              <b-field class='pars-set-select'>
                <b-select placeholder="メインロボと同じ" :value="miniroboPartsSets[i]['partsset']" @input="updateSelect($event, i)" :disabled="scenarioEdit.is_confirm">
                  <option v-for="(partsSet, index) in partsSetChoices" :key="index" :value="partsSet.robo_parts_set_id">
                    {{partsSet.robo_parts_set_name}}
                  </option>
                </b-select>
              </b-field>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scenarioEdit: {
      type: Object,
      required: true,
    },
    chatbot: {
      type: Object,
      required: true,
    },
    roboPartsSet: {
      type: Array,
      required: true,
    }
  },
  computed: {
    partsSetChoices () {
      return [{robo_parts_set_id: null, robo_parts_set_name:'メインロボと同じ'}].concat(this.roboPartsSet)
    },
    getRoboPartsSet () {
      const partsSet = this.roboPartsSet.find(partsSet => partsSet.robo_parts_set_id == this.scenarioEdit.robo_parts_set)
      return partsSet.robo_parts_set_id
    },
    miniroboPartsSets () {
      if (this.scenarioEdit.parameter['minirobos']) {
        // すでにパーツセットが設定されているミニロボはそのまま、設定されていなければnull
        return this.chatbot.chatbot_mini.map((robo) => {
          const robo2 = this.scenarioEdit.parameter['minirobos'].find((robo2) => robo2['pk'] == robo.pk)
          return robo2 || {pk: robo.pk, partsset: null}
        })
      }
      else {
        // 全てnull
        return this.chatbot.chatbot_mini.map((robo) => {return {pk: robo.pk, partsset: null}})
      }
    }
  },
  methods: {
    updateSelect (event, index) {
      if (index == -1) {
        const partsSet = this.roboPartsSet.find(partsSet => partsSet.robo_parts_set_id == event)
        this.scenarioEdit.robo_parts_set = partsSet.robo_parts_set_id
        this.scenarioEdit.parameter['robo_parts_set_name'] = partsSet.robo_parts_set_name
      }
      else {
        let partsSets = this.miniroboPartsSets
        partsSets[index]['partsset'] = event
        this.scenarioEdit.parameter['minirobos'] = partsSets
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.message-container {
  .message-wrapper {
    background-color:white;
    .-title {
      font-size: 16px;
      padding: 16px;
      text-align: center;
    }
    .select-wrapper {
      font-size: 13px;
      padding: 16px;
      justify-content: center;
      display: flex;
    }
  }
}
.table-wrapper {
  width: 90%;
  margin: 0 5%;
  height: 400px;
  overflow-y: scroll;
  display: block;
  .table-box {
    width: 100%;
    display: inline-table;
    .table-cell {
      text-align: center;
      vertical-align: middle;
      .parts-set-select {
        display: inline;
      }
    }
  }
}

.table-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/chatbot/scenarioEdit/ScenarioEditRoboPartsSet.vue